import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchInternalProductsApi } from 'api/products-api';
import toast from 'react-hot-toast';
import { getErrorString } from 'utils';

const initialState = {
  products: [],
  loading: true,
  pagination: {},
};

export const fetchUserProducts = createAsyncThunk('products', async (updatedParamsObject = {}, { getState }) => {
  try {
    const payload = {
      ...updatedParamsObject,
    };
    const res = await fetchInternalProductsApi(payload);
    return res;
  } catch (error) {
    toast.error(getErrorString(error));
  }
});

const UserProductSlice = createSlice({
  name: 'user-products',
  initialState,
  reducers: {
    setUserProducts: (state, action) => {
      state.products = action?.payload?.data ?? state.products;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchUserProducts.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUserProducts.fulfilled, (state, action) => {
        if (action?.payload?.data) {
          state.products = action?.payload?.data ?? [];
          state.pagination = action?.payload?.meta?.pagination ?? {};
        }
        state.loading = false;
      })
      .addCase(fetchUserProducts.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default UserProductSlice.reducer;
export const { setUserProducts } = UserProductSlice.actions;
